module.exports = __webpack_public_path__ + "static/media/undraw_blank_canvas_3rbb.6d6e7ddf.svg";